/**
 * Promotion councils hidden from the Export Directory sidebar filter on shops list pages.
 * Matching is case-insensitive on trimmed names.
 */
export const HIDDEN_PROMOTION_COUNCIL_FILTERS = [
  "Apeda",
  "Apparel Export",
  "Ayush",
  "Carpet",
  "Cashew",
  "Chemexcil",
  "Cocount",
  "Coffee",
  "Coir",
  "EEPC",
  "EPCES",
  "Gulfood",
] as const;

const HIDDEN_PROMOTION_COUNCIL_FILTER_KEYS = new Set(
  HIDDEN_PROMOTION_COUNCIL_FILTERS.map((name) => name.toLowerCase())
);

export function isHiddenPromotionCouncilFilter(name: string): boolean {
  const key = String(name || "").trim().toLowerCase();
  return key.length > 0 && HIDDEN_PROMOTION_COUNCIL_FILTER_KEYS.has(key);
}

export function filterPromotionCouncilFilterOptions(names: string[]): string[] {
  return names.filter((name) => !isHiddenPromotionCouncilFilter(name));
}
